<template>
  <div id="drag-wrapper"  class="card" @keydown.stop >
    <div class="h-title-con">
      <div class="h-title">
        <span class="title-text"><span class="title-tip"></span>新增系统账号</span>
      </div>
      <div class="h-button-warpper">
        <el-button size="small" @click="saveForm"  type="primary">保存</el-button>
        <el-button size="small" @click="back"  type="primary">返回</el-button>
      </div>
    </div>
  </div>

</template>

<script>
  import { mapGetters } from 'vuex'

  import commonMixin from '@/mixins/common.js'
  export default {
    name: 'edit',
    mixins: [commonMixin],
    data() {
      return {
        selectElement: null
      }
    },
    methods: {
      back(isRefresh) {
        const path = '/config/%2Ftemplate%2Fmodule%2Fcustomer%2Fcustomer_page_config.json'
        this.goBack(path)
        if (isRefresh) {
          this.$nextTick(() => {
            this.$bus.$emit('refresh-grid')
          })
        }
      }
    },
    computed: {
      ...mapGetters([
        'sidebar'
      ])
    },
    mounted() {
    },
    created() {
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/systemAccount/edit.vue